export default {
      Products: 'المنتج|المنتجات',
      Products_no_body: 'منتج',
};
